{
  const Cookie = require('./Cookie');
  module.exports = {
    getUserName() {
      return Cookie.get('UserName', 'MISCGCs') || Cookie.get('UserName');
    },
    getSecureUserToken() {
      // return Cookie.get('secure_user_token');
      // returning false as secure_user_token is not accessible
      return false;
    },
    isSecureUserTokenAlive() {
      const tokenExpiry = Number(Cookie.get('STExpiry', 'MISCGCs'));
      return Date.now() < tokenExpiry;
    },
    isSignedIn() {
      return Boolean(Cookie.get('SignedIn') === '1' && this.isSecureUserTokenAlive());
    },
    isSoftSignedIn() {
      return (this.getUserName() && !this.isSignedIn());
    },
    isNewSoftSignedIn() {
      return this.isSoftSignedIn();
    },
  };
}
